export default __webpack_public_path__ + "static/media/title.1e843752.png";